import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    inject
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { firstValueFrom } from "rxjs";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ValidationContext } from "~app/common/validation/validationContext";
import { SetReferensnummerVerifieringsnummerCommand } from "~app/features/planera/commands/SetReferensnummerVerifieringsnummerCommand";
import { IArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";
import { EudrAnmalanDto } from "../../../model/EudrAnmalanDto";
import { EudrService } from "../../../services/eudr.service";

@Component({
    selector: "rask-arbetsorder-eudr",
    imports: [
        RaskCommonModule,
        FormsModule
    ],
    templateUrl: "./arbetsorder-eudr.component.html",
    styleUrl: "./arbetsorder-eudr.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArbetsorderEudrComponent implements OnInit, OnChanges {
    @Input() arbetsorder!: IArbetsorderDetail;
    @Input() validationContext: ValidationContext;
    savedReferensnummer: string;
    savedVerifieringsnummer: string;
    referensnummer: string;
    verifieringsnummer: string;
    eudrAnmalan = { items: [] as EudrAnmalanDto[] };

    private readonly eudrService = inject(EudrService);
    private readonly cdr = inject(ChangeDetectorRef);

    setReferensnummerVerifieringsnummer = () => {
        const cmd = new SetReferensnummerVerifieringsnummerCommand((instance) => {
            instance.arbetsorderId = this.arbetsorder.id;
            instance.referensnummer = this.arbetsorder.referensnummer;
            instance.verifieringsnummer = this.arbetsorder.verifieringsnummer;
        });
        if (!ObjectUtils.stringHasValue(this.arbetsorder.referensnummer) || !ObjectUtils.stringHasValue(this.arbetsorder.verifieringsnummer)) {
            this.arbetsorder.commandManager.remove(cmd);
        } else {
            this.arbetsorder.commandManager.updateCommand(cmd);
        }

    };

    ngOnInit(): void {
        this.loadExistingEudrData();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.arbetsorder && !changes.arbetsorder.firstChange) {
            this.loadExistingEudrData();
        }
    }

    getEudrRubrik(): string | undefined {
        if (this.arbetsorder.anskaffningsform === "Import") {
            return "EUDR Import";
        }
        if (this.arbetsorder.anskaffningsform === "Egen terminal") {
            return "EUDR Egen terminal";
        }
        return undefined;
    }

    private async loadExistingEudrData(): Promise<void> {
        try {
            const existingData = await firstValueFrom(
                this.eudrService.getAll(this.arbetsorder.guid)
            );
            if (existingData && existingData.length > 0) {
                this.eudrAnmalan.items = existingData;
                const eudrData = existingData.find(item => item.gallande) || existingData[0];
                this.savedReferensnummer = eudrData.referens || "";
                this.savedVerifieringsnummer = eudrData.verifiering || "";
                this.arbetsorder.referensnummer = "";
                this.arbetsorder.verifieringsnummer = "";
            } else {
                this.eudrAnmalan.items = [];
            }
        } catch (error) {
            console.error("Kunde inte hämta befintliga EUDR-värden:", error);
        }
        this.cdr.markForCheck();
    }
}
